var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 14.375C6.625 14.375 6.875 14.625 6.875 15C6.875 15.375 6.625 15.625 6.25 15.625C5.875 15.625 5.625 15.375 5.625 15C5.625 14.625 5.9375 14.375 6.25 14.375ZM6.25 13.125C5.1875 13.125 4.375 13.9375 4.375 15C4.375 16.0625 5.1875 16.875 6.25 16.875C7.3125 16.875 8.125 16.0625 8.125 15C8.125 13.9375 7.3125 13.125 6.25 13.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.375C15.375 14.375 15.625 14.625 15.625 15C15.625 15.375 15.375 15.625 15 15.625C14.625 15.625 14.375 15.375 14.375 15C14.375 14.625 14.6875 14.375 15 14.375ZM15 13.125C13.9375 13.125 13.125 13.9375 13.125 15C13.125 16.0625 13.9375 16.875 15 16.875C16.0625 16.875 16.875 16.0625 16.875 15C16.875 13.9375 16.0625 13.125 15 13.125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12497 6.25H16.3652C17.0331 6.25 17.5133 6.89219 17.3244 7.53282L16.0625 11.8125C15.8125 12.9375 14.8125 13.75 13.625 13.75H5.62497L4.1875 6.75C3.875 5.375 2.6875 4.375 1.25 4.375",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H16.25",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.875C6.59518 6.875 6.875 6.59518 6.875 6.25C6.875 5.90482 6.59518 5.625 6.25 5.625C5.90482 5.625 5.625 5.90482 5.625 6.25C5.625 6.59518 5.90482 6.875 6.25 6.875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.88a18566.svg";
export { ForwardRef as ReactComponent };